import { FullWidthCard } from "/react4xp/components/cards/FullWidthCard";

export default (props) => <FullWidthCard {...props} />;
